import { render } from "./feature-four.vue?vue&type=template&id=38a759f2"
import script from "./feature-four.vue?vue&type=script&lang=js"
export * from "./feature-four.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__